export default "__VITE_ASSET__97d6d8ed__"